import { Flex, Stack, StackProps } from "@chakra-ui/react";
import * as React from "react";

export interface PageBodyProps extends StackProps {
  children?: React.ReactNode;
}

export default function PageBody(props: PageBodyProps) {
  const { ...rootProps } = props;
  return (
    <Flex flex="1" {...rootProps}>
      <Stack flex="1" gap="5">
        {props.children}
      </Stack>
    </Flex>
  );
}
